import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { PAGINAS, ROUTES, FUNCIONALIDADES } from '../../../routes';
import { getTiposDocumentos } from './tipos_documentos_service';
import GridBase from '../../../components/grid_base';
import StatusPesquisar from '../../../components/status_pesquisar';
var LIMITE_BUSCA = 100;
var COLUNAS = [
    {
        field: 'nome',
        headerName: 'Nome',
        width: 650,
    },
    {
        field: 'situacao',
        headerName: 'Situação',
        width: 150,
    },
];
export var TiposDocumentosListar = function () {
    return (_jsx(GridBase, { pagina: PAGINAS.TIPOS_DOCUMENTOS, paginaPermissao: FUNCIONALIDADES.TIPOS_DOCUMENTOS, rota: ROUTES.TIPOS_DOCUMENTOS, columns: COLUNAS, filtrosIniciais: {
            situacao: '-1',
        }, fetchData: function (textoBusca, filtros, paginationModel) {
            var textoTratado = textoBusca ? textoBusca.slice(0, LIMITE_BUSCA) : null;
            return getTiposDocumentos(textoTratado === '' ? null : textoTratado, filtros.situacao === '-1' ? null : filtros.situacao, paginationModel);
        }, renderFiltros: function (filtros, atualizarFiltros) { return (_jsx(StatusPesquisar, { StatusPesquisa: filtros.situacao, filtrarGrid: function (_, novaSituacao) {
                atualizarFiltros({ situacao: novaSituacao });
            } })); } }));
};
export default TiposDocumentosListar;
